module.exports = __webpack_public_path__ + "img/ic_linkedin_bg_black.427de4c2.svg";